export const CURRENT_PASSWORD_FIELD_NAME = 'CurrentPassword';
export const NEW_PASSWORD_FIELD_NAME = 'NewPassword';
export const CONFIRM_PASSWORD_FIELD_NAME = 'ConfirmPassword';
